export enum FloodReportStatusType {
    PendingRequest = 0,
    PendingUploadToBlobStorage = 1,
    Complete = 2,
    NotFound = 3,
    RequiresManualResearch = 4,
    MissingInformation = 5,
    Error = 6,
    Cancelled = 7,
    PendingCancel = 8,
}
